<template>
  <y-block-box title="版本管理">
    <template #suffix>
      <div>
        <el-button plain type="success" size="small" icon="el-icon-document-add" @click="handleAdd()">版本新增</el-button>
        <el-button plain type="primary" size="small" icon="el-icon-refresh" @click="fnQuery()">列表刷新</el-button>
      </div>
    </template>
    <div>
      <el-table :data="versions" :row-class-name="tableRowClassName" height="80vh">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="expand-box">
              <div class="expand-title">{{ scope.row.version }}发布说明</div>
              <div class="expand-note">{{ scope.row.releaseNote }}</div>
            </div>
            <div class="expand-box">
              <div class="expand-title">sha256 校验和</div>
              <div class="expand-note">{{ scope.row.sha256 }}</div>
            </div>
            <div class="expand-box">
              <div class="expand-title">CDN域名</div>
              <div class="expand-note">{{ scope.row.origin }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台架构" prop="platform" sortable :sort-by="['platform', 'arch']" :sort-orders="['ascending', 'ascending']" width="100px" align="left">
          <template slot-scope="scope">
            <div>
              <img v-if="scope.row.origin === 'pan.baidu.com'" class="table-scope-logo" src="../../../static/百度网盘.svg">
              <img v-else-if="scope.row.platform === 'windows'" class="table-scope-logo"
                   src="../../../static/windows.svg">
              <img v-else-if="scope.row.platform === 'kylinos'" class="table-scope-logo" src="../../../static/银河麒麟.svg">
              <span>
                {{ scope.row.arch }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="versionID" label="版本号" width="200px" align="left" sortable>
        </el-table-column>

        <el-table-column prop="verdate" label="版本时间" width="100px" align="left" sortable>
          <span slot-scope="scope">
            {{ scope.row.verdate ? new Date(scope.row.verdate).toLocaleDateString() : '/' }}
          </span>
        </el-table-column>
        <el-table-column label="标签" :sort-by="['latest', 'online']" :sort-orders="['descending', 'descending']" sortable>
          <template slot-scope="scope">
              <el-tag v-if="scope.row.latest" size="mini">最新版</el-tag>
              <el-tag v-if="!scope.row.online" type="danger" size="mini">未上架</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="format" label="格式" width="100px" sortable>
        </el-table-column>
        <el-table-column label="文件" width="400px">
          <template slot-scope="scope">
            <div @click="copyText(scope.row.url)" style="cursor: pointer;">
              <i class="el-icon-document-copy" style="padding:0 8px;"></i>
              <el-link type="primary">{{ scope.row.filename }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="展示名称" prop="version" width="200px" sortable>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="300px">
          <template slot-scope="scope">
            <el-button size="mini" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="startDelete(scope.row)">
              删除
            </el-button>
            <el-button size="mini" :icon="scope.row.online ? 'el-icon-s-release' : 'el-icon-s-promotion'"
                       :type="scope.row.online ? 'warning' : 'success'" @click="handleOnline(scope.row)">
              {{ scope.row.online ? '下架' : '上架' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="operate.operateType === 'edit' ? '版本编辑' : '新增版本'" @closed="resetOperate"
                 :close-on-click-modal="false" :visible.sync="operate.visible" width="560px" center>
        <version-operate v-if="operate.visible" @addSuccess="closeAndRefresh" @editSuccess="closeAndRefresh"
                         :operateType="operate.operateType" :editInfo="operate.editInfo"></version-operate>
      </el-dialog>

      <el-dialog title="警告" :visible="!!delCheckForm.id" width="560px" @close="delCheckForm.id = ''">
        <div style="display: flex;flex-direction: column;gap: 14px;">
          <div style="letter-spacing: 1px;">
            确定要从数据库中 <span style="color: #f56c6c;font-weight:bold;font-size: 16px;">永久删除</span> 该项吗？
            建议优先使用 <span style="color: #e6a23c;font-weight:bold;font-size: 16px;">下架</span> 功能隐藏该版本。
          </div>
          <el-input v-model="delCheckForm.confirmVersion" placeholder="请输入需要删除的版本号"></el-input>
          <el-input v-model="delCheckForm.password" placeholder="请输入删除令牌"></el-input>
          <div slot="footer" style="display: flex;gap: 5px;">
            <y-spacer></y-spacer>
            <el-button @click="delCheckForm.id = ''">取 消</el-button>
            <el-popconfirm title="确定要永久删除？" @confirm="fnDeleteCheck">
              <el-button slot="reference" type="primary">确定删除</el-button>
            </el-popconfirm>
          </div>
        </div>
      </el-dialog>
    </div>
  </y-block-box>
</template>

<script>
import VersionOperate from './versionOperate.vue';
// const DEFAULT_PASSWORD = '1301400'
export default {
  name: 'version',
  components: { VersionOperate },
  props: {},
  data() {
    return {
      versions: [],
      operate: {
        visible: false,
        operateType: 'add', //add or edit
        editInfo: {},
      },
      delCheckForm: {
        id: '',
        version:'', // 选择需要删除的版本名
        versionID:"",
        confirmVersion:'', // 用户输入的需要删除的版本名
        password: ''
      },
      delCheckDialog: false, // 版本物理删除密码校验弹窗
    }
  },
  mounted() {
    this.fnQuery()
  },
  methods: {
    handleOnline(info) {
      let lineStatus = 0
      if (info.online) {
        // 下架
        lineStatus = 0
      } else {
        // 上架
        lineStatus = 1
      }
      this.$callApi({ name: "lineOnOrOut", data: { lineStatus, recordId: info._id }, config: { mask: true, method: "post" } }).then(res => {
        if (res.data.updated) {
          this.fnQuery()
        } else {
          this.$message.error('上架下架失败，请联系管理员')
        }
      }).catch(e => {
        console.error(e);
      })
    },
    tableRowClassName({ row, rowIndex }) {
      return row.online ? '' : 'outLine-row';
    },
    resetOperate() {
      this.operate.operateType = 'add'
      this.operate.editInfo = {}
    },
    copyText(text)
    {
      this.$copyText(text);
    },
    async fnQuery() {
      await this.$callApi({ name: "versionsAll", config: { mask: true, method: "post" } }).then(res => {
        this.versions = res.data.map((i)=>{
          let slice = i.url.split("/");
          i.filename = slice[slice.length-1];
          let slice2 = i.url.split(".")
          i.format = slice2[slice2.length-1];
          if(i.format.length > 10)
          {
            i.format = ""
          }
          return i;
        });
      }).catch(e => {
        console.error(e);
      })
    },
    handleEdit(index, info) {
      this.operate.operateType = 'edit'
      this.operate.editInfo = JSON.parse(JSON.stringify(info))
      this.operate.visible = true
    },
    // 版本删除
    async handleDelete(recordId) {
      try {
        if (!recordId) {
          throw new Error('删除文件id为空');
        }
        console.log('删除文件', recordId)
        const res = await this.$callApi({
          name: "deleteFile",
          data: { recordId: recordId },
          config: { mask: true, method: "post" }
        });

        if (res.data.removeRes.deleted > 0) {
          await this.fnQuery();
        } else {
          throw new Error('文件删除失败，请联系管理员');
        }
      } catch (e) {
        this.$message.error(e.message);
        return Promise.reject(e);
      }
    },
    startDelete(row){
      this.delCheckForm.id = row._id;
      this.delCheckForm.version = row.version;
      this.delCheckForm.versionID = row.versionID;
      this.delCheckForm.confirmVersion = ''
    },
    handleAdd() {
      this.operate.visible = true
    },
    closeAndRefresh() {
      this.fnQuery()
      this.operate.visible = false
    },
    // 删除输入密码后校验
    async fnDeleteCheck() {
      if (!this.delCheckForm.id) {
        this.$message.error('尚未选择删除内容！')
        return
      }
      if(this.delCheckForm.confirmVersion !== this.delCheckForm.versionID){
        this.$message.error('输入的版本号和选择的版本号不一致！')
        return
      }
      try{
        const res = await this.$callApi({
            name: "admin.checkToken",
            data: { token: this.delCheckForm.password },
            config: { method: "post" }
        });
        if (res.status == 0 && res.data) {
          await this.handleDelete(this.delCheckForm.id)
          this.$message.success('删除成功')
          this.delCheckForm.id = ''
        } else {
          this.$message.error('令牌错误， 请重试')
        }
      }catch(e)
      {
        this.$message.error('令牌错误， 请重试')
        // pass
      }
      
    }
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-table .el-table__body td .cell:empty::after {
  content: '/';
}

.table-scope-logo {
  height: 16px;
  width: auto;
  margin-right: 4px;
}

.expand-box {
  margin: 20px;

  .expand-title {
    font-weight: bold;
    margin-bottom: 12px;
    color: #005CD6;
  }

  .expand-note {
    white-space: pre-line;
    line-height: 1.5;

    &:empty::after {
      content: '暂无内容';
    }
  }
}

/deep/.el-table {
  .outLine-row>td.el-table__cell {
    background: #f3f9ff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/version/version.vue